/** Is this address a client's dashboard (`/c/{slug}/...`) rather than the console? */
export function isPortalPath(pathname: string): boolean {
  return /^\/c\/[^/]+(\/|$)/.test(pathname)
}
